import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Button, Typography, useTheme } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Login } from '@mui/icons-material';
import { loginRequest, LOGIN_TYPE } from '@/app/authConfig';
import store from '@/app/store/store';

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = ({ showListItem, color, ...props }) => {
	const { sx, ...otherProps } = props ?? {};

	const theme = useTheme();
	const itemColor = color ?? theme.palette.sideNavItems;
	const isDarkMode = theme.palette.mode === 'dark';
	const { instance } = useMsal();

	const handleLogin = (loginType) => {
		localStorage.clear();
		if (loginType === 'popup') {
			instance.loginPopup(loginRequest).catch((e) => {
				console.log('🙅 ~ ', e);
			});
		} else if (loginType === 'redirect') {
			instance.loginRedirect(loginRequest).catch((e) => {
				console.log('🙅 ~ ', e);
			});
		}
	};

	return (
		<>
			{showListItem ? (
				<ListItemButton
					onClick={() => handleLogin(LOGIN_TYPE)}
					sx={{
						borderRadius: '20px',
						'&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.1)' },
					}}
				>
					<ListItemIcon sx={{ color: itemColor }}>
						<Login />
					</ListItemIcon>
					<ListItemText
						primary='Sign in'
						sx={{ fontWeight: 'bold', marginLeft: '-12px', color: itemColor }}
					/>
				</ListItemButton>
			) : (
				<Button
					onClick={() => handleLogin(LOGIN_TYPE)}
					sx={{
						display: 'flex',
						alignItems: 'center',
						backgroundColor: isDarkMode ? theme.palette.background.paper : '#F5F5F5',
						color: isDarkMode ? theme.palette.text.primary : '#787878',
						padding: '30px 70px',
						border: `2px solid ${isDarkMode ? theme.palette.divider : '#DFE1E5'}`,
						...(sx ?? {}),
					}}
					{...(otherProps ?? {})}
				>
					<img
						src='/Microsoft_logo.png'
						alt='Microsoft Logo'
						style={{ marginRight: '8px', height: '30px', width: '30px' }}
					/>
					<Typography variant='body1' sx={{ fontWeight: 'bold' }}>
						Login with Microsoft
					</Typography>
				</Button>
			)}
		</>
	);
};
